module.exports = __webpack_public_path__ + "static/media/logo-s2Pay.cf317c23.png";